// @flow

import React, { Fragment } from "react";

import Sort from "./../Sort/Sort";
import AppliedFilter from "./../AppliedFilter/AppliedFilter";

type PropsType = {
	count: number,
	sortOrder: string,
	appliedFilters: TopicListAppliedFilterType[],
	path: string,
	isLoading: boolean
};

export const ResultsInfo = (props: PropsType) => (
	<div className="filter-summary">
		<div className="filter-summary__count">
			<h2 className="h5 mv--0" aria-live="assertive" id="results-info-count">
				{props.isLoading ? (
					<span aria-busy="true">Loading…</span>
				) : (
					<Fragment>Showing {props.count} product{props.count === 1 ? "" : "s"}</Fragment>
				)}
			</h2>
		</div>
		<div className="filter-summary__sorting hide-print">
			<Sort sortOrder={props.sortOrder} path={props.path} />
		</div>
		{props.appliedFilters.length > 0 &&
			<ul className="results-info__filters hide-print">
				{props.appliedFilters.map(filter => <AppliedFilter key={`${filter.groupId}:${filter.optionId}`} appliedFilter={filter} path={props.path} />)}
			</ul>
		}
	</div>
);

export default ResultsInfo;
